import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@mui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  filterSize: {
    fontSize: 10,
    width: 20,
    height: 20
  }
});

const FilterAvatar = ({ alt, src }) => {
  const { classes } = useStyles();
  return <Avatar className={classes.filterSize} src={src} alt={alt || ''} />;
};

FilterAvatar.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string
};

export default FilterAvatar;
